import {
  SocialSyncRunStatus,
  SocialTrackerStatus,
} from '@digital-twins/shared-types'

export type SocialStatusTone = 'positive' | 'progress' | 'warning' | 'destructive' | 'muted'

const IN_PROGRESS_STATUSES: ReadonlyArray<SocialTrackerStatus> = [
  'queued',
  'collecting',
  'indexing',
]

const RETRYABLE_STATUSES: ReadonlyArray<SocialTrackerStatus> = ['partial', 'failed']

export function isTrackerInProgress(status: SocialTrackerStatus): boolean {
  return IN_PROGRESS_STATUSES.includes(status)
}

/** Partial and failed offer Retry; every other status offers Run now. */
export function isTrackerRetryable(status: SocialTrackerStatus): boolean {
  return RETRYABLE_STATUSES.includes(status)
}

export function trackerStatusTone(status: SocialTrackerStatus): SocialStatusTone {
  switch (status) {
    case 'ready':
      return 'positive'
    case 'queued':
    case 'collecting':
    case 'indexing':
      return 'progress'
    case 'partial':
    case 'rate_limited':
    case 'over_budget':
      return 'warning'
    case 'failed':
      return 'destructive'
    case 'paused':
      return 'muted'
  }
}

export function runStatusTone(status: SocialSyncRunStatus): SocialStatusTone {
  switch (status) {
    case 'succeeded':
      return 'positive'
    case 'queued':
    case 'running':
    case 'indexing':
      return 'progress'
    case 'partial':
    case 'rate_limited':
    case 'over_budget':
      return 'warning'
    case 'failed':
      return 'destructive'
  }
}

export const STATUS_TONE_BADGE_VARIANT: Record<
  SocialStatusTone,
  'positive' | 'info' | 'warning' | 'soft-destructive' | 'muted'
> = {
  positive: 'positive',
  progress: 'info',
  warning: 'warning',
  destructive: 'soft-destructive',
  muted: 'muted',
}
